<template>
  <div class="goods-wrapper">
    <div class="test-goods-container">
      <div class="go-back" @click="$emit('goBack')">
        <img
          alt=""
          src="@/assets/images/trialProductsList/detailBack.png"
          style="margin: 6px 0 0 10px; opacity: 0.8"
          width="26px"
          height="26px"
        />
      </div>
      <van-swipe @change="onChange">
        <van-swipe-item v-for="(image, index) in swiperArr" :key="index">
          <img v-lazy="image" />
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            <span class="active-numbers">{{ current + 1 }}</span>
            <span v-if="Slash" class="Slash">/</span>
            <span class="total-numbers">{{ swiperArr.length }}</span>
          </div>
        </template>
      </van-swipe>
    </div>
    <div
      v-if="state"
      class="test-goods-introduction"
      @click="goJump(goodsParams)"
    >
      <div class="tagWrap">
        <openWxTag
          :id="'xmyxItem' + goodsParams.productId + goodsParams.id"
          :path="`/subPackages/shopMainProcess/product/index?productId=${goodsParams.productId}&skuId=${goodsParams.skuId}`"
          :btnStyle="btnStyle"
          @sensorsFn="goJump(goodsParams)"
        >
        </openWxTag>
      </div>
      <div class="test-goods-imgs">
        <img :src="goodsParams.img" alt="" />
      </div>
      <div class="test-goods-detail">
        <div class="test-goods-title">{{ goodsParams.title }}</div>
        <div class="test-goods-jump" v-html="buttonTest"></div>
      </div>
    </div>
  </div>
</template>

<script>
import openWxTag from '@/components/common/openWeappTag/index.vue'
import { goToMini, TestUserAgent } from '@/assets/js/common.js'
import { BuiedPointClick_Fn } from '@/assets/js/BuriedPointEvent'

export default {
  components: { openWxTag },
  data() {
    return {
      current: 0, //当前的轮播图片,
      issystem: TestUserAgent().isios,
    }
  },
  props: {
    /**
     * goodParams 一个商品对象
     * images:轮播图数组
     * img:商品图
     * title：商品标题
     * 可根据自己使用进行后期的改动
     */
    goodsParams: {
      type: Object,
    },
    swiperArr: {
      type: Array,
    },
    Slash: {
      type: Boolean,
      default: false,
    },
    back: {
      type: String,
      default: require('@/assets/images/trialProductsList/back.png'),
    },
    buttonTest: {
      type: String,
      default: '点击进入商品详情',
    },
    state: {
      type: Boolean,
      default: false,
    },
    point: {
      type: Boolean,
      default: false,
    },
    from: {
      type: String,
      default: '',
    },
    btnStyle: {
      type: String,
      default: 'width:100%;height:62px;',
    },
  },
  watch: {},
  computed: {},
  // 方法集合
  methods: {
    goToMini,
    onChange(index) {
      this.current = index
    },
    goJump(goodsParams) {
      if (this.from === 'communityDetail') {
        console.log('走商品详情')
        BuiedPointClick_Fn('xmhh5CommunityClick', {
          xmhh5_Community_Goods_Click: goodsParams.title,
        })
        BuiedPointClick_Fn('xmhh5CommunityGoodsClick', {
          xxhh5_Community_AGoods_Click: goodsParams.title,
        })
      }
      if (this.from === 'evaluationDetail') {
        BuiedPointClick_Fn('xmhh5_freetrial_productclick', {
          xmhh5_freetrial_detailitem_click: goodsParams.title,
        })
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
}
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
.test-goods-container {
  position: relative;
  width: 375px;
}

/deep/ .van-swipe__track {
  justify-content: center;
  align-items: center;
}

/deep/ .van-swipe-item {
  width: 100%;
  //height: 375px;
  img {
    width: 100%;
    //height: 100%;
  }
}

.goods-wrapper {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.custom-indicator {
  position: absolute;
  right: 11px;
  bottom: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;

  // line-height: 19px;
  .active-numbers {
    display: block;
    // width: 19px;
    height: 18px;
    background: #333333;
    padding: 0px 4px 0px 7px;
    border-radius: 9px 0px 0px 9px;
    opacity: 0.4;
  }

  .total-numbers {
    display: block;
    // width: 19px;
    height: 18px;
    padding: 0px 7px 0px 5px;
    background: #333333;
    border-radius: 0px 9px 9px 0px;
    opacity: 0.3;
  }
}

.go-back {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 99;
}

.test-goods-introduction {
  position: relative;
  margin: 12px 12px 0;
  padding: 11px 10px 11px 0px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  position: relative;

  .test-goods-imgs {
    width: 106px;
    height: 92px;
    display: flex;
    justify-content: center;
    border-radius: 4px;

    img {
      width: 92px;
      height: 100%;
      border-radius: 5px;
    }
  }

  .test-goods-detail {
    padding-left: 10px;
    // width: 206px;
    // padding:3px 0 0 17px ;
    .test-goods-title {
      height: 42px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      word-break: break-all;
      font-weight: 500;
      color: #333333;
      // line-height: 21px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .test-goods-jump {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fd6771;
      line-height: 20px;
      padding-top: 8px;
    }
  }
}

.tagWrap {
  width: 351px;
  height: 62px;
  position: absolute;
  top: 0px;
  right: 12px;
  z-index: 99;
}
</style>
